import { useQuery } from "@tanstack/react-query";
import { apiClient } from "../../../../lib/api-client";
import { SupportInformation } from "../types/SupportInformation";

export const useGetSupportInformation = () => {
	const { data, isLoading } = useQuery({
		queryKey: ['support-info'],
		queryFn: async () => await apiClient.get('help/support-info') as SupportInformation
	});

	return {
		data,
		isLoading
	};
};
